
// import React from "react";
// import { FaSearch, FaBars } from "react-icons/fa";
// import logo from "../img/aaaservices/LogoIIAHead.png";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

// const CustomNavbar = () => {
//   return (
//     <>
//       <nav
//         className={`navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm px-3`}
//         style={{ zIndex: 1000 }}
//       >
//         {/* Logo Section */}
//        <Link to="/" className="navbar-brand d-flex align-items-center">
//           <img src={logo} alt="Logo" height="60" className="me-2" />
//           <span
//             className="text-logo"
//             style={{
//               fontWeight: "bold",
//               color: "orange",
//               fontSize: "20px",
//             }}
//           >
//           INTERNATIONAL INSTITUTE <span style={{ color: "blue" }}>OF AUTOMATE</span>
//           </span>
//         </Link>

//         {/* Hamburger Toggle */}
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarContent"
//           aria-controls="navbarContent"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <FaBars />
//         </button>

//         {/* Collapsible Content */}
//         <div className="collapse navbar-collapse mt-2 mt-lg-0" id="navbarContent">
//           <ul className="navbar-nav ms-auto w-100 d-flex flex-column flex-lg-row align-items-start align-items-lg-center">
//             {/* Search Bar */}
//             <li className="nav-item w-100 mb-2 mb-lg-0 me-lg-3">
           
//               <div
//                 style={{
//                   display: "flex",
//                   justifyContent: "center",
//                   alignItems: "center",
//                   padding: "20px",
//                 }}
//               >
//                 <div
//                   className="position-relative"
//                   style={{
//                     maxWidth: "421px",
//                     width: "100%",
//                     borderRadius: "40px",
//                   }}
//                 >
//                   <FaSearch
//                     style={{
//                       position: "absolute",
//                       top: "50%",
//                       left: "12px",
//                       transform: "translateY(-50%)",
//                       color: "#999",
//                       fontSize: "14px",
//                       zIndex: 1,
//                     }}
//                   />
//                   <input
//                     type="text"
//                     className="form-control ps-5 search-input"
//                     placeholder="Search Here"
//                     style={{
//                       borderRadius: "30px",
//                       paddingLeft: "40px",
//                       height: "45px",
//                       border: "1px solid #ccc",
//                     }}
//                   />
//                 </div>
//               </div>
//             </li>

//             {/* City Dropdown */}
//             <li className="nav-item mb-2 mb-lg-0 me-lg-3">
//               <select className="form-select">
//                 <option>Hyderabad</option>
//                 <option>Delhi</option>
//                 <option>Mumbai</option>
//                 <option>Bangalore</option>
//               </select>
//             </li>

//             {/* Social Icons */}
//             <li className="nav-item">
//               <div className="d-flex gap-3 fs-5">
//                 <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" style={{ color: "#3b5998" }}>
//                   <i className="fab fa-facebook-f"></i>
//                 </a>
//                 <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ color: "#0077b5" }}>
//                   <i className="fab fa-linkedin-in"></i>
//                 </a>
//                 <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" style={{ color: "#E1306C" }}>
//                   <i className="fab fa-instagram"></i>
//                 </a>
//                 <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" style={{ color: "#FF0000" }}>
//                   <i className="fab fa-youtube"></i>
//                 </a>
//               </div>
//             </li>
//           </ul>
//         </div>

//         {/* Font Awesome Icons */}
//         <link
//           rel="stylesheet"
//           href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
//           integrity="sha512-dyZt8sI6Mvy3KzvMg+6kJZu3iU2XPOJ+K9vZEv0Zp4bNwKOGD0H4K7MeYQ+6XnKJMGX9ZqZtR2q6UpM0MUPVmA=="
//           crossOrigin="anonymous"
//           referrerPolicy="no-referrer"
//         />
//       </nav>
//     </>
//   );
// };

// export default CustomNavbar;





// import React, { useEffect, useState } from "react";
// import { FaSearch, FaBars } from "react-icons/fa";
// import logo from "../img/aaaservices/LogoIIAHead.png";
// import { Link } from "react-router-dom";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "bootstrap/dist/js/bootstrap.bundle.min";

// const CustomNavbar = () => {
//   const [showNavbar, setShowNavbar] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       setShowNavbar(window.scrollY > 100);
//     };

//     window.addEventListener("scroll", handleScroll);
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <>
//       <nav
//         className={`navbar navbar-expand-lg fixed-top px-3 transition-navbar ${showNavbar ? "navbar-scrolled" : "navbar-top"}`}
//         style={{ zIndex: 1000 }}
//       >
//         {/* Logo */}
//         <Link to="/" className="navbar-brand d-flex align-items-center">
//           <img src={logo} alt="Logo" height="60" className="me-2" />
//           <span className="text-logo">
//             INTERNATIONAL INSTITUTE <span className="text-blue">OF AUTOMATE</span>
//           </span>
//         </Link>

//         {/* Toggle Button */}
//         <button
//           className="navbar-toggler"
//           type="button"
//           data-bs-toggle="collapse"
//           data-bs-target="#navbarContent"
//           aria-controls="navbarContent"
//           aria-expanded="false"
//           aria-label="Toggle navigation"
//         >
//           <FaBars />
//         </button>

//         {/* Navbar Content */}
//         <div className="collapse navbar-collapse mt-2 mt-lg-0" id="navbarContent">
//           <ul className="navbar-nav ms-auto w-100 d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-end gap-3">
            
//             {/* Search Bar */}
//             <li className="nav-item w-100 w-lg-auto">
//               <div className="search-wrapper">
//                 {/* <FaSearch className="search-icon" /> */}
//                 <input
//                   type="text"
//                   className="form-control search-input"
//                   placeholder="Search Here"
//                 />
//               </div>
//             </li>

//             {/* City Dropdown */}
//             <li className="nav-item">
//               <select className="form-select city-dropdown">
//                 <option>Hyderabad</option>
//                 <option>Delhi</option>
//                 <option>Mumbai</option>
//                 <option>Bangalore</option>
//               </select>
//             </li>

//             {/* Social Media Icons */}
//             <li className="nav-item">
//               <div className="d-flex gap-2 social-icons">
//                 <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#3b5998" }}>
//                   <i className="fab fa-facebook-f text-white"></i>
//                 </a>
//                 <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#0077b5" }}>
//                   <i className="fab fa-linkedin-in text-white"></i>
//                 </a>
//                 <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#E1306C" }}>
//                   <i className="fab fa-instagram text-white"></i>
//                 </a>
//                 <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#FF0000" }}>
//                   <i className="fab fa-youtube text-white"></i>
//                 </a>
//               </div>
//             </li>
//           </ul>
//         </div>

//         {/* Font Awesome CDN */}
//         <link
//           rel="stylesheet"
//           href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
//           integrity="sha512-dyZt8sI6Mvy3KzvMg+6kJZu3iU2XPOJ+K9vZEv0Zp4bNwKOGD0H4K7MeYQ+6XnKJMGX9ZqZtR2q6UpM0MUPVmA=="
//           crossOrigin="anonymous"
//           referrerPolicy="no-referrer"
//         />
//       </nav>

//       {/* Internal Styles */}
//       <style>{`
//         .transition-navbar {
//           transition: background-color 0.3s ease, box-shadow 0.3s ease;
//           width: 100%;
//         }
//         .navbar-top {
//           background-color: transparent !important;
//           box-shadow: none !important;
//         }
//         .navbar-scrolled {
//           background-color: #fff !important;
//           box-shadow: 0 2px 5px rgba(0,0,0,0.1) !important;
//         }
//         .text-logo {
//           font-weight: bold;
//           color: orange;
//           font-size: 20px;
//         }
//         .text-blue {
//           color: blue;
//         }
//         .search-wrapper {
//           position: relative;
//           max-width: 400px;
//           width: 100%;
//         }
//         .search-icon {
//           position: absolute;
//           top: 50%;
//           left: 12px;
//           transform: translateY(-50%);
//           color: #999;
//           font-size: 14px;
//           z-index: 1;
//         }
//         .search-input {
//           padding-left: 35px;
//           border-radius: 30px;
//           height: 40px;
//           font-size: 14px;
//           border: 1px solid #ccc;
//         }
//         .city-dropdown {
//           width: 160px;
//           border-radius: 30px;
//           padding-left: 15px;
//           height: 40px;
//           font-size: 14px;
//           border: 1px solid #ccc;
//         }
//         .social-icons .social-circle {
//           width: 35px;
//           height: 35px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           border-radius: 50%;
//           text-decoration: none;
//         }
//         @media (max-width: 991px) {
//           .navbar-nav {
//             align-items: flex-start !important;
//           }
//           .search-wrapper, .city-dropdown {
//             width: 100%;
//           }
//         }
//       `}</style>
//     </>
//   );
// };

// export default CustomNavbar;



import React from "react";
import { FaBars } from "react-icons/fa";
import logo from "../img/aaaservices/LogoIIAHead.png";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const CustomNavbar = () => {
  return (
    <>
      <nav
        className="navbar navbar-expand-lg fixed-top px-3 navbar-whiteye"
        style={{ zIndex: 1000 }}
      >
        {/* Logo */}
        <Link to="/" className="navbar-brand d-flex align-items-center">
          <img src={logo} alt="Logo" height="60" className="navlogo" />
          <span className="text-logo">
            INTERNATIONAL INSTITUTE <span className="text-blueyyy">OF AUTOMATE</span>
          </span>
        </Link>

        {/* Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <FaBars />
        </button>

        {/* Navbar Content */}
        <div className="collapse navbar-collapse mt-2 mt-lg-0" id="navbarContent">
          <ul className="navbar-nav ms-auto w-100 d-flex flex-column flex-lg-row align-items-start align-items-lg-center justify-content-end gap-3">
            
            {/* Search Bar */}
            <li className="nav-item w-100 w-lg-auto">
              <div className="search-wrapper">
                <input
                  type="text"
                  className="form-control search-input"
                  placeholder="Search Here"
                />
              </div>
            </li>

            {/* City Dropdown */}
            {/* <li className="nav-item" style={{marginRight:'62px'}}>
              <select className="form-select city-dropdown">
                <option>Hyderabad</option>
                <option>Delhi</option>
                <option>Mumbai</option>
                <option>Bangalore</option>
              </select>
            </li> */}

            {/* Social Media Icons */}
            {/* <li className="nav-item">
              <div className="d-flex gap-2 social-icons">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#3b5998" }}>
                  <i className="fab fa-facebook-f text-white"></i>
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#0077b5" }}>
                  <i className="fab fa-linkedin-in text-white"></i>
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#E1306C" }}>
                  <i className="fab fa-instagram text-white"></i>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-circle" style={{ backgroundColor: "#FF0000" }}>
                  <i className="fab fa-youtube text-white"></i>
                </a>
              </div>
            </li> */}
          </ul>
        </div>

        {/* Font Awesome CDN */}
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/css/all.min.css"
          integrity="sha512-dyZt8sI6Mvy3KzvMg+6kJZu3iU2XPOJ+K9vZEv0Zp4bNwKOGD0H4K7MeYQ+6XnKJMGX9ZqZtR2q6UpM0MUPVmA=="
          crossOrigin="anonymous"
          referrerPolicy="no-referrer"
        />
      </nav>

      {/* Internal Styles */}
      <style>{`
        .navbar-whiteye {
          background-color: blue !important;
          // box-shadow: 0 2px 5px rgba(0,0,0,0.1) !important;
          width: 100%;
          transition: background-color 0.3s ease, box-shadow 0.3s ease;
        }
        .text-logo {
          font-weight: bold;
          color: orange;
          font-size: 20px;
        }
        .text-blueyyy {
          color: blue;
        }
        .search-wrapper {
          position: relative;
          max-width: 400px;
          width: 100%;
        }
        .search-input {
          padding-left: 35px;
          border-radius: 30px;
          height: 40px;
          font-size: 14px;
          border: 1px solid #ccc;
        }
        .city-dropdown {
          width: 160px;
          border-radius: 30px;
          padding-left: 15px;
          height: 40px;
          font-size: 14px;
          border: 1px solid #ccc;
        }
        .social-icons .social-circle {
          width: 35px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          text-decoration: none;
        }
        @media (max-width: 991px) {
          .navbar-nav {
            align-items: flex-start !important;
          }
          .search-wrapper, .city-dropdown {
            width: 100%;
          }
        }
      `}</style>
    </>
  );
};

export default CustomNavbar;



